import React, { Component } from 'react'
import { Link, Navigate } from 'react-router-dom'
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import moment from 'moment';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import API from "../../config/api";
import { exportToExcel } from "../Helper/exportToExcel";

export class VideoReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      nb_days: 15,
      data: [],
      nav_id: null,
      date: new Date(),
      startDate: null,
      endDate: null,
      likes_7day: null,
      views_7days: null,
      last_month_likes: null,
      last_month_views: null,
      today_likes: null,
      today_views: null,
      total_likes: null,
      total_views: null,
      nb_views_30days: [],
      top_video: []
    }
  }

  componentWillMount() {
    this.getData();
    this.getVideosReport();
  }

  getRamdom() {
    return Math.floor(Math.random() * 1000) + 3000
  }

  getDay(i) {
    // return moment().subtract(i, 'months').format("MMM YYYY")
    return moment().subtract(i, 'day').format("DD")
  }

  getData() {
    // let tempArray = []
    // for (let i = this.state.nb_days; i > 0; i--) {
    //   tempArray.push({
    //     key: i,
    //     view_per_month: this.getRamdom(),
    //     name: this.getDay(i)
    //   })
    // }
    // this.setState({data: tempArray})
  }

  searchByDate = (range) => {
    const [startDate, endDate] = range;
    this.setState({startDate})
    this.setState({endDate})

    this.getVideosReport();
  };

  getVideosReport = async () => {
    try {
      // let query = `page=${this.state.page}`
      // moment().format("MMM Do YY");
      let query ='';
      let start_date = '';
      let end_date = '';
      
      if(this.state.startDate) {
        start_date = moment(this.state.startDate).format("YYYY-MM-DD");
        end_date = moment(this.state.endDate).format("YYYY-MM-DD");
      }
      

      console.log(start_date, end_date, this.state.nb_days)
      // let query = `nb_days=14`
      
      if(this.state.nb_days) {
        console.log(this.state.nb_days)
        query = `nb_days=${this.state.nb_days}`
      }

      if(start_date) {
        console.log(start_date)
        query = `start_date=${start_date}&&end_date=${end_date}`
      }

      // this.query = `start_date=${start_date}&&end_date=${end_date}`

      let results = await API.getVideosReport();
      let data = results.data
      console.log(data)

      let tempArray = []

      // for (let i = this.state.nb_days; i > 0; i--) {
      for (let i = data.nb_views_30days.length -1 ; i > -1; i--) {  
        tempArray.push({
          key: i,
          // active_users: this.getRamdom(),
          view_per_day: data.nb_views_30days[i],
          name: this.getDay(i+1)
        })
      }
      
      this.setState({ data: tempArray, likes_7day : data.likes_7day.toLocaleString('en-US'), views_7days: data.views_7days.toLocaleString('en-US'), last_month_likes: data.last_month_likes.toLocaleString('en-US'),
        last_month_views: data.last_month_views.toLocaleString('en-US'), today_likes: data.today_likes.toLocaleString('en-US'), today_views: data.today_views.toLocaleString('en-US'), total_likes: data.total_likes.toLocaleString('en-US'),
        total_views: data.total_views.toLocaleString('en-US'), top_video: data.top_video
       });

    } catch (error) {
      console.log(error)
    }
  }

  exportVideosToExcel = (data, filename) => {
    exportToExcel(data, filename);
  }

  render() {
    return (
      <div class="col-lg-12">
        {/* {this.state.nav_id && (
           <Navigate to={`/videoview?id=${this.state.nav_id}`} replace={true} />
        )} */}

        <div className="flexbox mb-20">
          <div className="lookup">
            {/* <input className="w-200px" type="text" name="s" placeholder="Search" onChange={this.onSearch} /> */}
            <DatePicker
                className="w-300px"
                showIcon
                icon="fa fa-calendar"
                selected={this.state.startDate}
                onChange={this.searchByDate}
                startDate={this.state.startDate}
                endDate={this.state.endDate}
                // minDate={this.state.startDate}
                placeholderText="Select specific day"
                dateFormat="MMMM d, yyyy"
                isClearable
                selectsRange
              />
          </div>

          <div className="btn-toolbar">
            <div className="btn-group btn-group-sm">
            <button className="btn btn-info dropdown-toggle" data-toggle="dropdown">Export</button>
              <div className="dropdown-menu dropdown-menu-right">
                  <Link class="dropdown-item"  ><i class="fa fa-file-zip-o"></i> Zip</Link>
                  <Link class="dropdown-item"  ><i class="fa fa-file-pdf-o"></i> PDF</Link>
                  <Link class="dropdown-item" onClick={(event) => {this.exportVideosToExcel(this.state.top_video, "top videos report")}}  ><i class="fa fa-file-excel-o"></i> Excel</Link>
              </div>
              <select data-provide="selectpicker" data-width="100">
                <option>Today</option>
                <option>Yesterday</option>
                <option>Last week</option>
                <option>Last month</option>
                <option>All time</option>
              </select>
            </div>
          </div>
         </div>
          <div>
        </div>


        <div class="card">
        
          <div className='row'>
            <div class="col-md-6 col-xl-3">
              <div class="card card-body bg-danger">
                <h6 class="text-uppercase text-white">Today likes</h6>
                <div class="flexbox mt-2">
                  <span class="fa fa-heart fs-30"></span>
                  <span class="fs-30">{this.state.today_likes}</span>
                </div>
              </div>
            </div>
            
            <div class="col-md-6 col-xl-3">
              <div class="card card-body bg-purple">
                <h6 class="text-uppercase text-white">Last 7 days likes</h6>
                <div class="flexbox mt-2">
                  <span class="fa fa-heart fs-30"></span>
                  <span class="fs-30">{this.state.likes_7day}</span>
                </div>
              </div>
            </div>
            <div class="col-md-6 col-xl-3">
              <div class="card card-body bg-info">
                <h6 class="text-uppercase text-white">Last month likes</h6>
                <div class="flexbox mt-2">
                  <span class="fa fa-heart fs-30"></span>
                  <span class="fs-30">{this.state.last_month_likes}</span>
                </div>
              </div>
            </div>
            <div class="col-md-6 col-xl-3">
              <div class="card card-body bg-success">
                <h6 class="text-uppercase text-white">Total likes</h6>
                <div class="flexbox mt-2">
                  <span class="fa fa-heart fs-30"></span>
                  <span class="fs-30">{this.state.total_likes}</span>
                </div>
              </div>
            </div>
          </div>
          <div className='row'>
            <div class="col-md-6 col-xl-3">
              <div class="card card-body bg-danger">
                <h6 class="text-uppercase text-white">Today Views</h6>
                <div class="flexbox mt-2">
                  <span class="fa fa-eye fs-30"></span>
                  <span class="fs-30"> {`${this.state.today_views}`}</span>
                </div>
              </div>
            </div>
            
            <div class="col-md-6 col-xl-3">
              <div class="card card-body bg-purple">
                <h6 class="text-uppercase text-white">Last 7 days Views</h6>
                <div class="flexbox mt-2">
                  <span class="fa fa-eye fs-30"></span>
                  <span class="fs-30">{this.state.views_7days}</span>
                </div>
              </div>
            </div>
            <div class="col-md-6 col-xl-3">
              <div class="card card-body bg-info">
                <h6 class="text-uppercase text-white">Last month Views</h6>
                <div class="flexbox mt-2">
                  <span class="fa fa-eye fs-30"></span>
                  <span class="fs-30">{this.state.last_month_views}</span>
                </div>
              </div>
            </div>
            <div class="col-md-6 col-xl-3">
              <div class="card card-body bg-success">
                <h6 class="text-uppercase text-white">Total Views</h6>
                <div class="flexbox mt-2">
                  <span class="fa fa-eye fs-30"></span>
                  <span class="fs-30">{this.state.total_views}</span>
                </div>
              </div>
            </div>
          </div>
          {/* <div class="col-md-6 col-xl-3">
            <div class="card card-body">
              <h6>
                <span class="text-uppercase">Visitors</span>
                <span class="float-right"><a class="btn btn-xs btn-primary" href="#">View</a></span>
              </h6>
              <br />
              <p class="fs-28 fw-100">18,964</p>
              <div class="progress">
                <div class="progress-bar bg-success" role="progressbar" style={{width: "85%", height: "4px"}} aria-valuenow="85" aria-valuemin="0" aria-valuemax="100"></div>
              </div>
              <div class="flexbox text-gray fs-12">
                <span><i class="ti-arrow-up text-success mr-1"></i> %25 up</span>
                <span>+1000</span>
              </div>
            </div>
          </div> */}
          </div>

          <div className='card'>
            <div class="card-header">
              <h5 class="card-title">View Previous Days</h5>
            </div>
            <div class="card-body">
                {
                  this.state.data.length != 0 && 
                  <div  style={{width: '100%', height: 300 }}>
                  <ResponsiveContainer debounce={300} width="100%" height="100%">
                    <BarChart
                      width={500}
                      height={300}
                      data={this.state.data}
                      margin={{
                        top: 5,
                        right: 30,
                        left: 20,
                        bottom: 5,
                      }}
                      barSize={20}
                    >
                      <XAxis dataKey="name" scale="point" padding={{ left: 10, right: 10 }} />
                      <YAxis />
                      <Tooltip />
                      <Legend />
                      <CartesianGrid strokeDasharray="3 3" />
                      <Bar dataKey="view_per_day" fill="#4ed2c5" background={{ fill: '#eee' }} />
                    </BarChart>
                  </ResponsiveContainer>
                  </div>
                }
              </div>
          </div>


          <div className='card'>

          <div class="card-header">
            <h5 class="card-title"><strong>User Report</strong></h5>
            <div className="btn-group btn-group-sm ml-2 d-none d-sm-flex">
          {/* <Link class="btn btn-xs btn-light" to=''>See all</Link> */}
            

            {/* <button className="btn btn-info dropdown-toggle" data-toggle="dropdown">Export</button>
            <div className="dropdown-menu dropdown-menu-right">
                <Link class="dropdown-item"  ><i class="fa fa-file-zip-o"></i> Zip</Link>
                <Link class="dropdown-item"  ><i class="fa fa-file-pdf-o"></i> PDF</Link>
                <Link class="dropdown-item"  ><i class="fa fa-file-excel-o"></i> Excel</Link>
            </div>
            <select data-provide="selectpicker" data-width="100">
              <option>Yesterday</option>
              <option>Last week</option>
              <option>Last month</option>
              <option>All time</option>
            </select> */}
                
            </div>
          </div>

          <table class="table table-hover">
            <thead>
              <tr>
                <th>#</th>
                <th>Name</th>
                <th>Episode</th>
                <th>Total like</th>
                <th>Total View</th>
                <th>Release Date</th>
                <th class="w-80px text-center">Action</th>
              </tr>
            </thead>
            <tbody>
            { this.state.top_video &&
                this.state.top_video.map((data, index) => {
                  return <tr>
                      <td>{index+1}</td>
                      <td>{data.title_kh}</td>
                      <td>{data.nb_episodes}</td>
                      <td>{data.total_likes}</td>
                      <td class="align-middle">
                        <div class="progress mb-0">
                          <div class="progress-bar" role="progressbar" style={{width: "95%", height: 13}} aria-valuenow="90" aria-valuemin="0" aria-valuemax="100"><b>{data.total_views.toLocaleString('en-US')}</b></div>
                        </div>
                      </td>
                      <td>{moment(data.release_date).format("DD-MMM-YYYY")}</td>
                      <td>
                        <nav class="nav no-gutters gap-2 fs-16">
                          <Link class="nav-link hover-primary" title="View" to={`/videoview?id=${data.id}`} data-provide="tooltip" ><i class="ti-eye"></i></Link>
                          {/* <a class="nav-link hover-danger" href="#" data-provide="tooltip" title="Delete"><i class="ti-trash"></i></a> */}
                        </nav>
                      </td>
                  </tr>
                })
            }
              
            </tbody>
          </table>

        </div>
      </div>
    )
  }
}

export default VideoReport